import { Stack } from '@mui/material'
import ThoughtTimelineExtraRow from './ThoughtTimelineExtraRow'

export default function ThoughtTimelineExtras({ extras = [], streaming = false }) {
  if (!extras.length) return null
  return (
    <Stack sx={{ gap: 0 }}>
      {extras.map((item) => (
        <ThoughtTimelineExtraRow
          key={item.id ?? item.kind}
          item={item}
          streaming={streaming}
        />
      ))}
    </Stack>
  )
}
